<script>
import options from "./ShopFilter.options";
export default options;
</script>

<template>
    <aside class="nti-shop-filter" :class="{ 'nti-shop-filter--open' : displayFilters }">
        <div class="nti-shop-filter__button-container nti-shop-filter__button-container--mobile-filter">
            <button class="nti-button" @click="toggleFilters" :class="{ 'nti-button--selected' : displayFilters}">
                <div class="nti-svg__container-medium nti-svg--filter">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"/></svg>
                </div>
                {{ verifyLabel("filterMobileButtonLabel") }}
                <div class="nti-svg__container-medium nti-svg--drop-down" :class="{ 'nti-svg--drop-down-selected' : displayFilters}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"/></svg>
                </div>
            </button>
        </div>

        <div class="nti-shop-filter__wrapper" :class="{ 'nti-shop-filter__wrapper--open' : displayFilters }">
            <article class="nti-shop-filter__section">
                <h3 class="nti-shop-filter__title">{{ verifyLabel("filterHeadingCategoryLabel") }}</h3>
                <section class="nti-shop-filter__level-one">
                    <template v-for="(category,index) in categories" :key="index">
                       <div>
                            <article v-if="category.key != 'Industry' && category.key != 'Manufacturer' && category.displayName != 'DoNOTShow'" class="nti-shop-filter__level-one__wrapper">
                                <div class="nti-shop-filter__level-one__label-container">
                                    <input :id="`category-level-one-checkbox-id-${category.key}`"
                                            class="nti-shop-filter__checkbox"
                                            role="checkbox"
                                            type="checkbox"
                                            @change="selectFilter(category.key,category.value)"
                                            v-model="category.selected"
                                            :name="category.key"
                                            :disabled="category.documentCount === 0 && !category.selected"
                                        />
                                    <label class="nti-shop-filter__label" :for="`category-level-one-checkbox-id-${category.key}`">{{ category.displayName}} ({{category.documentCount}})</label>
                                </div>
                                <template v-for="(group,groupIndex) in category.facetGroups" :key="groupIndex">
                                    <section class="nti-shop-filter__level-two" v-if="category.selected">
                                        <span class="nti-shop-filter__level-two__title" v-if="group.displayName">{{group.displayName}}</span>
                                        <ul class="nti-shop-filter__level-two__container">
                                            <template v-for="(value,valueIndex) in group.values" :key="valueIndex">
                                                <li class="nti-shop-filter__level-two__label-container">
                                                    <input :id="`category-level-two-checkbox-id-${value.key}`" 
                                                        class="nti-shop-filter__checkbox"
                                                        role="checkbox"
                                                        type="checkbox"
                                                        @change="selectFilter(group.key,value.key)" 
                                                        v-model="value.selected" 
                                                        :name="value.key"
                                                        :disabled="value.documentCount === 0 && !value.selected"
                                                    />
                                                    <label class="nti-shop-filter__label" :for="`category-level-two-checkbox-id-${value.key}`">{{ value.displayName}} ({{value.documentCount}})</label>
                                                </li>
                                            </template>
                                        </ul>
                                    </section>
                                </template>
                            </article>
                       </div>
                    </template>
                </section>
            </article>

            <template v-for="(category, categoryIndex) in categories" :key="'industry-' + categoryIndex">
                <article v-if="category.key === 'Industry' && category.documentCount != 0" class="nti-shop-filter__section">
                    <h3 class="nti-shop-filter__title">{{ verifyLabel("filterHeadingIndustryLabel") }}</h3>
                    <section class="nti-shop-filter__level-one">
                        <template v-for="(group,groupIndex) in category.facetGroups" :key="groupIndex">
                            <ul class="nti-shop-filter__level-two__container nti-shop-filter__level-two__container--no-sub-header">
                                <template v-for="(value,valueIndex) in group.values" :key="valueIndex">
                                    <li class="nti-shop-filter__level-two__label-container">
                                        <input :id="`industry-checkbox-id-${valueIndex}`" class="nti-shop-filter__checkbox"
                                            role="checkbox"
                                            type="checkbox"
                                            @change="selectFilter(group.key,value.key)" 
                                            v-model="value.selected" 
                                            :name="value.key"
                                            :disabled="value.documentCount === 0 && !value.selected"
                                        />
                                        <label class="nti-shop-filter__label" :for="`industry-checkbox-id-${valueIndex}`">{{ value.displayName}} ({{value.documentCount}})</label>
                                    </li>
                                </template>
                            </ul>
                            </template>
                    </section>
                </article>
            </template>

            <template v-for="(category, categoryIndex2) in categories" :key="'manufacturer-' + categoryIndex2">
                <article v-if="category.key === 'Manufacturer' && category.documentCount != 0" class="nti-shop-filter__section">
                    <h3 class="nti-shop-filter__title">{{ verifyLabel("filterHeadingManufacturerLabel") }}</h3>
                    <section class="nti-shop-filter__level-one">
                        <template v-for="(group,groupIndex) in category.facetGroups" :key="groupIndex">
                            <ul class="nti-shop-filter__level-two__container nti-shop-filter__level-two__container--no-sub-header">
                                <template v-for="(value,valueIndex) in group.values" :key="valueIndex">
                                    <li class="nti-shop-filter__level-two__label-container">
                                        <input :id="`manufacturer-checkbox-id-${value.key}`" class="nti-shop-filter__checkbox"
                                            role="checkbox"
                                            type="checkbox"
                                            @change="selectFilter(group.key,value.key)" 
                                            v-model="value.selected" 
                                            :name="value.key"
                                            :disabled="value.documentCount === 0 && !value.selected"
                                        />
                                        <label class="nti-shop-filter__label" :for="`manufacturer-checkbox-id-${value.key}`">{{ value.displayName}} ({{value.documentCount}})</label>
                                    </li>
                                </template>
                            </ul>
                            </template>
                    </section>
                </article>
            </template>
        
            <div class="nti-shop-filter__button-container">
                <button class="nti-button" @click="clearFilters">{{ verifyLabel("clearFilterLabel") }}</button>
            </div>
        </div>
    </aside>
</template>




